import API from "@/services/api";
import {  
  IContractationConfirmResponse,
  IDNIValidationResponse,
  IScoringResponse,
  StepConfirmationFormDataAPI,
  IStepConfirmationResponseData,
  IStepSentResponse,
  StepsFormDataAPI
} from "../types/stepsAPI";

enum Endpoints {
  ContractationConfig = "/contractacio/config",
  Scoring = "/leads/solvencia/:lead_id",
  DNIValidation = "/leads/dni-validation/:lead_id",
  Leads = "/leads",
  GasContractationConfig = "/gas/contractacio/config/cups/:cups",
  GasLeads = "/gas/leads"
}

const fetchContractationConfig = () => {
  return new Promise<IContractationConfirmResponse>(async (resolve, reject) => {
    API.get<IContractationConfirmResponse>({
      endpoint: Endpoints.ContractationConfig,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const fetchGasContractationConfig = (cups: string) => {
  return new Promise<IContractationConfirmResponse>(async (resolve, reject) => {
    API.get<IContractationConfirmResponse>({
      endpoint: Endpoints.GasContractationConfig,
      params: {
        cups
      },
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const sendLeadStepData = (
  data: StepsFormDataAPI
) => {
  return new Promise<IStepSentResponse>(async (resolve, reject) => {
    API.post<IStepSentResponse, StepsFormDataAPI>({
      endpoint: Endpoints.Leads,
      data,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const sendGasLeadStepData = (
  data: StepsFormDataAPI
) => {
  return new Promise<IStepSentResponse>(async (resolve, reject) => {
    API.post<IStepSentResponse, StepsFormDataAPI>({
      endpoint: Endpoints.GasLeads,
      data,
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const confirmContractation = (
  data: StepConfirmationFormDataAPI
) => {
  return new Promise<IStepConfirmationResponseData>(async (resolve, reject) => {
    API.post<IStepConfirmationResponseData, StepConfirmationFormDataAPI>({
      endpoint: Endpoints.Leads,
      data,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const confirmGasContractation = (
  data: StepConfirmationFormDataAPI
) => {
  return new Promise<IStepConfirmationResponseData>(async (resolve, reject) => {
    API.post<IStepConfirmationResponseData, StepConfirmationFormDataAPI>({
      endpoint: Endpoints.GasLeads,
      data,
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const checkLeadScore = (
  leadId: number
) => {
  return new Promise<IScoringResponse>(async (resolve, reject) => {
    API.get<IScoringResponse>({
      endpoint: Endpoints.Scoring,
      params: {
        lead_id: leadId
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const checkLeadDNI = (
  leadId: number
) => {
  return new Promise<IDNIValidationResponse>(async (resolve, reject) => {
    API.get<IDNIValidationResponse>({
      endpoint: Endpoints.DNIValidation,
      params: {
        lead_id: leadId
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchContractationConfig,
  fetchGasContractationConfig,
  sendLeadStepData,
  sendGasLeadStepData,
  checkLeadScore,
  checkLeadDNI,
  confirmContractation,
  confirmGasContractation
};


